import React from 'react'
import Icon from '@mdi/react'

import Logo from '@assets/logo_tema_horizontal.png'

import Checkbox from '@mui/material/Checkbox'
import './styles.scss'
const ValidationMessage: React.FC<{check: boolean, setCheck: any}> = ({check, setCheck}) => {


    return(
<>
        <div id = "listaTermos">

            <div id = "header">
                <img src = {Logo} alt = "Defense Access" />
            </div>
<div>
<p>Nos próximos segundos, faremos o cadastro de sua imagem no sistema.</p>
<p>Para que tudo saia bem, precisaremos que você siga as seguintes recomendações:</p>
</div>
  <ul className='recomendacoes-lista'>
    <li> - Procure um ambiente com boa iluminação;</li>
    <li> - Faça o procedimento com uma parede clara ao fundo;</li>
    <li> - Não utilize óculos escuros;</li>
    <li> - Se puder, também, não utilize óculos de grau;</li>
    <li> - Não utilize chapéus (bonés, gorros etc);</li>
    <li> - Mantenha a cabeça reta e direcionada para a câmera de seu dispositivo;</li>
    <li> - Procure não fazer gestos faciais (piscar, mostrar a língua etc);</li>
    <li> - Mantenha os olhos abertos e direcione seu olhar para a câmera de seu dispositivo;</li>
    <li> - Tente preencher a forma elíptica na imagem;</li>
    <li> - Siga as instruções para continuação;</li>
  </ul>

  <div id='termoAceite'>
<div>  
    <Checkbox color='error' checked={check} onChange={() => setCheck(!check)} inputProps={{ 'aria-label': 'controlled' }} />
    <label className='error' style={{ fontSize: '16px'}}> Concordo em seguir as recomendações </label>
    </div> 
            <p className="warning">(concorde para continuar)</p>
</div>
        </div>



</>
    )

}

export default ValidationMessage